
      <div class="grid" *ngIf="carInformacionInicial">
        <div class="col-12 md:col-12 lg:col-12 text-center">
          <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
          <span>{{'LBL_CONSULTANDO' | translate }}</span>
        </div>
      </div>
      <div *ngIf="!carInformacionInicial">
        <div class="grid">
          <div class="col-12">
            <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event)">
              <p-accordionTab header="{{ (modalidad ? 'MODALIDADES.LBL_EDITARMODALIDAD' : 'MODALIDADES.LBL_AGREGARMODALIDAD') | translate }}" [selected]="tabSeleccionado === 'INFO'">
                <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fModalidades" name="fModalidades">
                  <div class="grid form-group">
                    <div class="col-12 md:col-12 lg:col-4">
                      <div class="div-form">
                      <label>* {{ 'MODALIDADES.LBL_CODIGO' | translate }}</label>
                      <label *ngIf="modalidad" class="falso-combo-texto">{{modalidad.codigo}}</label>
                        <input *ngIf="!modalidad" type="text" pInputText id="codigo"
                               name="nomCodigo"
                               autocomplete="off"
                               formControlName="codigo"
                               [maxlength]="10"
                               codigos-reactive
                        >
                        <div class="p-message p-messages-error p-corner-all" *ngIf="!modalidad && submitted && f.codigo.invalid">
                          {{ 'MODALIDADES.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 md:col-12 lg:col-4">
                      <div class="div-form">
                        <label>* {{ 'MODALIDADES.LBL_NOMBRE' | translate }}</label>
                        <input type="text" pInputText id="nombre"
                               name="nomNombre"
                               autocomplete="off"
                               formControlName="nombre"
                               [maxlength]="20"

                        >
                        <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                          {{ 'MODALIDADES.LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 md:col-12 lg:col-4">
                      <div class="div-form">
                        <label>* {{ 'MODALIDADES.LBL_CODIGO_SHIVAM' | translate }}</label>
                        <input type="text" pInputText id="codigoShivam"
                               name="nomCodigoShivam"
                               autocomplete="off"
                               formControlName="codigoShivam"
                               [maxlength]="10"
                               codigos-reactive
                        >
                        <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigoShivam.invalid">
                          {{ 'MODALIDADES.LBL_CODIGO_SHIVAM' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="grid form-group">
                    <div class="col-12 md:col-12 lg:col-12">
                      <div class="div-form">
                        <label>* {{ 'MODALIDADES.LBL_DESCRIPCION' | translate }}</label>
                        <input type="text" pInputText id="descripcion"
                               name="nomDescripcion"
                               autocomplete="off"
                               formControlName="descripcion"
                               [maxlength]="1000"
                        >
                        <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.descripcion.invalid">
                          {{ 'MODALIDADES.LBL_DESCRIPCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="grid form-group" >
                    <div class="col-12 md:col-3 lg:col-3">
                      <div class="div-form div-form--aling">
                        <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="false"
                                    id="indicadorHabilitado"
                                    name="nomindicadorHabilitado"
                                    formControlName="indicadorHabilitado"></p-checkbox>
                      </div>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <div class="div-form div-form--aling">
                        <p-checkbox label="{{ 'MODALIDADES.LBL_CONVENIOFGA' | translate}}" binary="false"
                                    id="indicadorConvenioFga"
                                    name="nomindIcadorConvenioFga"
                                    formControlName="indicadorConvenioFga" (onChange)="validarIndicadorConvenioFga()"></p-checkbox>
                      </div>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3" *ngIf="f.indicadorConvenioFga.value">
                      <div class="div-form">
                        <label>* {{ 'MODALIDADES.LBL_PAGAREMATERIAL' | translate }}</label>
                        <p-dropdown disableTab
                          filter="filter"
                          id="idFgaMaterial"
                          name="nomIdFgaMaterial"
                          [options]="listasCodigosFgaMaterial"
                          formControlName="idFgaMaterial"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                          optionValue="value"
                          optionLabel="label"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        ></p-dropdown>
                        <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idFgaMaterial.invalid">
                          {{ 'MODALIDADES.LBL_PAGAREMATERIAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 md:col-3 lg:col-3" *ngIf="f.indicadorConvenioFga.value">
                      <div class="div-form">
                        <label>* {{ 'MODALIDADES.LBL_PAGAREINMATERIAL' | translate }}</label>
                        <p-dropdown disableTab
                          filter="filter"
                          id="idFgaInmaterial"
                          name="nomIdFgaInmaterial"
                          [options]="listasCodigosFgaInmaterial"
                          formControlName="idFgaInmaterial"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                          optionValue="value"
                          optionLabel="label"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        ></p-dropdown>
                        <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idFgaInmaterial.invalid">
                          {{ 'MODALIDADES.LBL_PAGAREINMATERIAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="grid form-footer-buttons">
                    <div class="form-group col-12">
                      <div *ngIf="!guardando">
                        <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                        <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                      type="submit"
                      pButton></button>
                      </div>
                      <div *ngIf="guardando">
                        <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                        <span>{{'LBL_GUARDANDO' | translate }}</span>
                      </div>
                    </div>
                  </div>
                </form>
              </p-accordionTab>
              <p-accordionTab header="{{ 'MODALIDADES.LBL_FACTORCREZCAMOS' | translate }}" [selected]="tabSeleccionado === 'FACT'" [disabled]="!modalidad">
                <app-modalidades-factor-crezcamos [modalidad]="modalidad" *ngIf="modalidad && modalidad.idModalidad"
                                                  (dismiss)="cambiarTabSeleccionado($event)">
                </app-modalidades-factor-crezcamos>

              </p-accordionTab>
              <p-accordionTab header="{{ 'MODALIDADES.LBL_TASA' | translate }}" [selected]="tabSeleccionado === 'TAS'" [disabled]="!modalidad">
                <app-modalidades-tasas [modalidad]="modalidad" *ngIf="modalidad && modalidad.idModalidad"
                                       (dismiss)="cambiarTabSeleccionado($event)">
                </app-modalidades-tasas>

              </p-accordionTab>
              <p-accordionTab header="{{ 'MODALIDADES.LBL_AGREGARDOCUMENTOS' | translate }}" [selected]="tabSeleccionado === 'AUT'" [disabled]="!modalidad">
                <app-modalidades-autorizaciones  [modalidad]="modalidad" *ngIf="modalidad && modalidad.idModalidad"
                                       (dismiss)="cambiarTabSeleccionado($event)"></app-modalidades-autorizaciones>
              </p-accordionTab>
              <p-accordionTab header="{{ 'MODALIDADES.LBL_CALIFICACION' | translate }}" [selected]="tabSeleccionado === 'CAL'" [disabled]="!modalidad">
              <app-modalidades-calificaciones [modalidad]="modalidad" *ngIf="modalidad && modalidad.idModalidad"
                                              (dismiss)="cambiarTabSeleccionado($event)"></app-modalidades-calificaciones>
              </p-accordionTab>
            </p-accordion>
            <div class="grid form-footer-buttons" *ngIf="modalidad && modalidad.idModalidad">
              <div class="form-group col-12">
                <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                        pButton (click)="regresar(false)"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
